import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AccountPage } from './pages/account/account.page';
import { LoginPage } from './pages/login/login.page';
import { ConfirmEmailPage } from './pages/confirm-email/confirm-email.page';
import { UserDataPage } from './pages/user-data/user-data.page';
import { BillingPage } from './pages/billing/billing.page';
import { SupportChatPage } from './pages/support-chat/support-chat.page';
import { AffiliatePage } from './pages/affiliate/affiliate.page';
import { VcaasPage } from './pages/vcaas/vcaas.page';
import { McpPage } from './pages/mcp/mcp.page';
import { CeoGuard } from './guards/ceo.guard';

const routes: Routes = [

  {
    path: 'login',
    loadChildren: () => import('./pages/sign-in-flow/sign-in-flow.module').then( m => m.SignInFlowPageModule)
  },
  {
    path: 'sign-in-flow',
    loadChildren: () => import('./pages/sign-in-flow/sign-in-flow.module').then( m => m.SignInFlowPageModule)
  },
  {
    path: 'onboarding-flow',
    loadChildren: () => import('./pages/onboarding-flow/onboarding-flow.module').then( m => m.OnboardingFlowPageModule)
  },
  {
    path: '',
    redirectTo: 'account',
    pathMatch:'full'
  },
  {
    path: 'old-login',
    component: LoginPage
  },
  {
    path: 'account',
    component: AccountPage
  },
  {
    path: 'confirm-email',
    component: ConfirmEmailPage
  },
  {
    path: 'user-data',
    component: UserDataPage
  },
  {
    path: 'billing',
    component: BillingPage
  },
  {
    path: 'support-chat',
    component: SupportChatPage
  },
  {
    path: 'affiliate',
    component: AffiliatePage
  },
  {
    path: 'vcaas',
    component: VcaasPage
  },
  {
    path: 'mcp',
    component: McpPage
  },
  {
    // CEO-only area (graphics dashboard / users / projects). Lazy-loaded and guarded;
    // account-backend independently enforces the same restriction on every request.
    path: 'ceo',
    canActivate: [CeoGuard],
    loadChildren: () => import('./pages/ceo/ceo.module').then( m => m.CeoModule)
  },
  {
    path: 'plan-selected',
    loadChildren: () => import('./pages/plans/plan-selected/plan-selected.module').then( m => m.PlanSelectedPageModule)
  },
  {
    path: 'payment-success',
    loadChildren: () => import('./pages/payment-success/payment-success.module').then( m => m.PaymentSuccessPageModule)
  },
  {
    path: 'payment-cancel',
    loadChildren: () => import('./pages/payment-cancel/payment-cancel.module').then( m => m.PaymentCancelPageModule)
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
